import { gql } from "@apollo/client";

export const DeleteBulkUser = gql`
mutation MyMutation($list_user_id: [Int!]) {
  delete_user(where: {id: {_in: $list_user_id}}) {
    affected_rows
  }
}
`;
export const RecoverBulkUser = gql`
mutation MyMutation($list_user_id: [Int!]) {
  update_user(where: {id: {_in: $list_user_id}}, _set: {is_soft_deleted: false}) {
    affected_rows
  }
}
`;
export const DeleteMultiUser = async (apolloClient: any,list_user_id: number[]) => {
  let status = 0;
  try{
    let { data: dataDeleteMulti } = await apolloClient.mutate({
      mutation: DeleteBulkUser,
      variables: {
        list_user_id: list_user_id
      }
    });
    status = 1;
  }catch(e){
    status = 0
  }
 
  return status;
}
export const RecoverMultiUser = async (apolloClient: any,list_user_id: number[]) => {
  let status = 0;
  try{
    let { data: dataDeleteMulti } = await apolloClient.mutate({
      mutation: RecoverBulkUser,
      variables: {
        list_user_id: list_user_id
      }
    });
    status = 1;
  }catch(e){
    status = 0
  }
 
  return status;
}
